// src/sot/primitives/SearchBar.jsx
import React from "react";

export default function SearchBar({
  value,
  onChange,
  placeholder = "Search",
  variant = "solid", // "solid" | "ghost"

  // ✅ standardised names
  leftIconSrc = null,
  onLeftIconClick,
  rightIconSrc = null,
  onRightIconClick,

  className = "",
  inputClassName = "",
}) {
  const isSolid = variant === "solid";

  return (
    <div
      className={[
        "w-full",
        isSolid
          ? "bg-[rgb(var(--clr-surface-cont-highest))] border border-[rgba(91,107,134,0.20)] shadow-[0_6px_16px_rgba(15,23,42,0.12)]"
          : "bg-transparent border border-transparent shadow-none",
        "rounded-[999px] h-12 px-3 flex items-center gap-2",
        className,
      ].join(" ")}
    >
      {leftIconSrc && (
        <button
          type="button"
          onClick={onLeftIconClick}
          className="h-9 w-9 rounded-full flex items-center justify-center"
          aria-label="Back"
        >
          <img src={leftIconSrc} alt="" className="h-6 w-6" draggable="false" />
        </button>
      )}

      {/* ✅ tiny spacing so chevron doesn't kiss the text */}
      <input
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        className={[
          "flex-1 bg-transparent outline-none",
          "text-label-large",
          "placeholder:text-on-surface-var text-on-surface",
          "ml-1", // ✅ requested spacing
          inputClassName,
        ].join(" ")}
      />

      {rightIconSrc && (
        <button
          type="button"
          onClick={onRightIconClick}
          className="h-9 w-9 rounded-full flex items-center justify-center"
          aria-label="Clear"
        >
          <img src={rightIconSrc} alt="" className="h-5 w-5" draggable="false" />
        </button>
      )}
    </div>
  );
}